import { jsx as o } from "react/jsx-runtime";
import m from "clsx";
import c from "./Skeleton.module.css.js";
const l = ({ size: r, className: i, style: t, ...e }) => /* @__PURE__ */ o(
  "div",
  {
    className: m(c.circleContainer, i),
    style: {
      height: `${r}px`,
      width: `${r}px`,
      ...t
    },
    ...e
  }
);
l.displayName = "Circle";
export {
  l as Circle
};
//# sourceMappingURL=Circle.js.map
